import React, {Component} from 'react';
import intl from 'react-intl-universal';
import {getIconSrc, iconToIntl, keys} from "../../../../../../utils/Utils";

import './IconButton.css';

class IconButton extends Component {

    onKeyPress = e => {
        if (e.charCode === keys.ENTER) {
            this.props.iconOnClick({pageX: window.innerWidth / 2, pageY: window.innerHeight / 2}, e.target);
        }
    }

    render() {
        const {className} = this.props;

        let buttonStyles = {
            backgroundImage: `url(${getIconSrc(this.props.icon.image) + '?' + this.props.icon.versionNum})`,
            backgroundColor: this.props.icon.color
        };
        return (
            <li
                tabIndex="0"
                onKeyPress={e => this.onKeyPress(e)}
                onMouseDown={this.props.iconOnClick}
                onClick={this.props.iconOnClick}
                role="button"
                className={className}
            >
                <div style={buttonStyles} className={"icon " + this.props.className}>
                    <span className="sr-offscreen">Add {this.props.icon.text} {intl.get(iconToIntl[this.props.type])}</span>
                </div>
                <div className="text">
                    {this.props.icon.text}
                </div>
            </li>
        );
    }
}

export default IconButton;



// WEBPACK FOOTER //
// ./src/scenes/MapContainer/components/DrawerContainer/components/IconButton/index.js